/** Visit-specific changes have their own indicator beside lifecycle state. */
import { VisitBrowseRow } from '@jms/model';
import { defineConditionalTag } from '../../shared/define.conditional.tag';

// Blue, not grey: a deviation from the plan is information the dispatcher should notice, and it is
// the only Visit pill that is `brand` — state and lifecycle deliberately leave blue to it.
export const visitModifiedTag = defineConditionalTag<VisitBrowseRow>(row => row.overridden ? { label: 'Modified', tone: 'brand' } : null);
